import _ from 'lodash';
import { printLogs } from '../utils';
import axios from 'axios';
// Dev URLS
// export const baseUrl = 'https://crmliteapi-d4bhg9d9bxepg7bh.westus3-01.azurewebsites.net';


// Prod URLS
export const baseUrl = 'https://ctdbapi.azurewebsites.net';

// Network Request Service
export const fetchApi = async (config) => {
    let url = baseUrl + config.endPoint

    const userToken = await localStorage.getItem("userToken")
    if (!_.isNil(userToken)) {
        config.headers.Authorization = "Bearer " + JSON.parse(userToken)
    }
    // console.log(config.type)
    let fetchObj = (config.type == 'POST' || config.type == 'PUT') ? {
        url: url,
        method: config.type,
        data: config.value,
        responseType: config.responseType || 'json', 
        headers: config.headers ? config.headers : {}
    } : {
        url: url,
        method: config.type,
        responseType: config.responseType || 'json', 
        headers: config.headers ? config.headers : {}
    }
    printLogs("Url", url);
    printLogs("Fetch Obj", fetchObj);
    return new Promise((resolve, reject) => {
        axios(fetchObj)
            .then(async (response) => {
                printLogs("Response", response);
                if (response.status == 401 || response.status == 400) {
                    let obj = {
                        json: response.data,
                        responseCode: response.status
                    }
                    resolve(obj);
                }
                else if (response.status === 204) {
                    let obj = {
                        json: response.data,
                        responseCode: response.status
                    }
                    resolve(obj);
                }
                else if (response.status != 200 && response.status != 201) {

                    let obj = {
                        json: false,
                        responseCode: response.status,
                    }
                    resolve(obj)
                    return;
                }
                let obj = {
                    json: response.data,
                    responseCode: response.status
                }
                resolve(obj);
            })
            .catch((error) => {
                printLogs('Error in API ', error.response)
                resolve(false);
            });
    })

}


